import type { IconButtonProps } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { HomePageSidebarButtonWrapper } from '../HomePageSidebarButtonWrapper';

type HomePageSideBarNotificationsButtonProps = {
  notificationAmount: number;
  isSelected?: boolean;
} & IconButtonProps;

export const HomePageSideBarNotificationsButton: React.FC<HomePageSideBarNotificationsButtonProps> = ({ notificationAmount, isSelected, ...buttonProps }) => {
  return (
    <HomePageSidebarButtonWrapper
      isSelected={isSelected}
      {...buttonProps}
    >
      <Box
        height="20px"
        width="20px"
        borderRadius="100%"
        padding="0px 5.91px 0px 5.91px"
        position="absolute"
        visibility={notificationAmount === 0 ? 'hidden' : 'visible'}
        top={0}
        right={0}
        sx={theme => ({
          backgroundColor: theme.palette.tertiary.main,
        })}
      >
        <Typography
          fontSize="10.91px"
          lineHeight="20px"
          fontWeight={500}
        >
          {notificationAmount}
        </Typography>
      </Box>
      <VyIcon
        color='#323232'
        icon="NotificationBell"
      />
    </HomePageSidebarButtonWrapper>
  );
};